module.exports = __webpack_public_path__ + "img/recr_reports_icon.f7ce9c4a.svg";